var map = {
	"./1minute.svg": 761,
	"./24.svg": 762,
	"./AlmaLinux.svg": 763,
	"./Customers/VPS-foods.jpg": 753,
	"./Customers/VPS-khandevane.jpg": 754,
	"./Customers/VPS-manufacturing-firms.jpg": 755,
	"./Customers/VPS-sunich.jpg": 756,
	"./Feature-3.svg": 764,
	"./Feature-4.svg": 765,
	"./Feature-5.svg": 766,
	"./Feature-8.svg": 767,
	"./Fedora.svg": 768,
	"./Google.svg": 769,
	"./HA.svg": 770,
	"./Isolation.svg": 771,
	"./P1.png": 772,
	"./P2.png": 773,
	"./P3.png": 774,
	"./P4.png": 775,
	"./P5.png": 776,
	"./PfSense.svg": 777,
	"./Rocky_Linux.svg": 778,
	"./Step1-m.svg": 779,
	"./Step1.svg": 780,
	"./Step2-m.svg": 781,
	"./Step2.svg": 782,
	"./Step3.svg": 783,
	"./Successful-Google-Cloud-Migration-1440x564_c 1.svg": 784,
	"./VPS_Info_.svg": 785,
	"./ads1.svg": 786,
	"./ads2.svg": 787,
	"./apache.svg": 788,
	"./architect.svg": 789,
	"./backup.svg": 790,
	"./calc.png": 791,
	"./centos.svg": 792,
	"./chooseOs.svg": 793,
	"./common-types.svg": 794,
	"./console.svg": 795,
	"./container.svg": 796,
	"./dashboard.svg": 797,
	"./ddos-c.svg": 798,
	"./ddos-d.svg": 799,
	"./ddos.svg": 800,
	"./debian.svg": 801,
	"./disaster.svg": 802,
	"./docker.svg": 803,
	"./everything.svg": 804,
	"./externalServer.svg": 805,
	"./firewall-new.svg": 806,
	"./firewall.png": 807,
	"./freeSupport.svg": 808,
	"./global.svg": 809,
	"./hq.svg": 810,
	"./iaas_catalogue.png": 811,
	"./ico.png": 812,
	"./image1.svg": 813,
	"./increase.svg": 814,
	"./infrustructure.svg": 815,
	"./ip.png": 816,
	"./iranServer.svg": 758,
	"./list-vps.svg": 817,
	"./mikrotik.svg": 818,
	"./mysql.svg": 819,
	"./nStep1-m.svg": 759,
	"./nStep1.svg": 760,
	"./nginx.svg": 820,
	"./nodejs.svg": 821,
	"./not-found-mobile.svg": 822,
	"./not-found.svg": 823,
	"./panel.svg": 824,
	"./pattern.png": 825,
	"./plans.svg": 826,
	"./plans/Maple.svg": 682,
	"./plans/Willow.svg": 683,
	"./plans/beech.svg": 684,
	"./plans/cedar.svg": 685,
	"./plans/pine.svg": 686,
	"./plans/poplar.svg": 687,
	"./platform.png": 827,
	"./platform2.png": 828,
	"./python.svg": 829,
	"./resource.svg": 830,
	"./service-mgs.svg": 831,
	"./service-vpc.svg": 832,
	"./service-vps.svg": 833,
	"./service.svg": 834,
	"./siem.svg": 835,
	"./sla.svg": 836,
	"./startup.svg": 837,
	"./support.svg": 838,
	"./test.svg": 839,
	"./top-ways.svg": 840,
	"./traffic-vps.svg": 841,
	"./ubuntu18.svg": 842,
	"./ubuntu22.svg": 843,
	"./uptime.svg": 844,
	"./video.png": 845,
	"./vps-header.svg": 752,
	"./vps-hourly.svg": 757,
	"./vps-platform.png": 846,
	"./vps1.png": 847,
	"./vps10.png": 848,
	"./vps2.png": 849,
	"./vps3.png": 850,
	"./vps4.png": 851,
	"./vps5.png": 852,
	"./vps6.png": 853,
	"./vps7.png": 854,
	"./vps8.png": 855,
	"./vps9.png": 856,
	"./vps_figure.png": 857,
	"./vps_icon.png": 858,
	"./vps_picture2.png": 859,
	"./vpspackage.png": 860,
	"./waf-c.svg": 861,
	"./waf-d.svg": 862,
	"./waf-icon-active.svg": 863,
	"./waf-icon.svg": 864,
	"./waf-vps.svg": 865,
	"./waf.svg": 866,
	"./windows.svg": 867,
	"./wordpress.svg": 868
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 671;